@if (imageUrl() && !imageFailed()) {
  <img class="esn-avatar__img" [src]="imageUrl()" alt="" (error)="imageFailed.set(true)" />
} @else {
  <span class="esn-avatar__initials" aria-hidden="true">{{ initials() }}</span>
}
